import { ChooseLandingPageOptions } from "generated/CoreApi_v1";
import { IntegrationLayout } from "layouts/IntegrationLayout";
import { Route, Routes } from "react-router";
import PerformaIntegration from "views/integration/PerformaIntegration";

class Paths {
    static readonly Performance = "Performance";
    static readonly Goals = "Goals";
}

export class IntegrationPaths {
    static readonly Prefix = "/integration";
    static readonly Performance = IntegrationPaths.Prefix + "/" + Paths.Performance;
    static readonly Goals = IntegrationPaths.Prefix + "/" + Paths.Goals;
}

export const IntegrationRouter = () => {
    return (
        <Routes>
            <Route element={<IntegrationLayout />} >
                <Route path={Paths.Performance} element={<PerformaIntegration landingPage={ChooseLandingPageOptions.Performance} />} />
                <Route path={Paths.Goals} element={<PerformaIntegration landingPage={ChooseLandingPageOptions.Goals} />} />
            </Route>
        </Routes>
    );
};
